import { Currency } from '@/core/currency/interfaces';

const BDT: Currency = {
    name: 'Bangladeshi Taka',
    demonym: 'Bangladeshi',
    majorSingle: 'Taka',
    majorPlural: 'Taka',
    codeNumeric: '050',
    symbol: '৳',
    symbolNative: '৳',
    minorSingle: 'Poisha',
    minorPlural: 'Poisha',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'BDT',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default BDT;
